import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import "../css/admin.css";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      navigate("/admin");
    } else {
      setError(result.error || "Error al iniciar sesión");
    }

    setLoading(false);
  };

  return (
    <div className="admin-login-shell">
      <div className="admin-login-grid">
        <section className="admin-login-copy">
          <p className="admin-section-label">SAV fotografía</p>
          <h1 className="admin-login-title">Panel de administración</h1>
          <p className="admin-login-text">
            Accede para subir, reemplazar o eliminar las imágenes del sitio.
          </p>
        </section>

        <section className="admin-login-card">
          <div className="admin-login-card-header">
            <p className="admin-login-kicker">Acceso privado</p>
            <h2>Iniciar sesión</h2>
          </div>

          {error ? <Alert variant="danger">{error}</Alert> : null}

          <Form onSubmit={handleSubmit} className="admin-login-form">
            <Form.Group className="mb-3" controlId="username">
              <Form.Label>Usuario</Form.Label>
              <Form.Control
                className="admin-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
            </Form.Group>

            <Form.Group className="mb-4" controlId="password">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                className="admin-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>

            <Button
              className="admin-primary-button w-100"
              variant="dark"
              type="submit"
              disabled={loading}
            >
              {loading ? "Iniciando sesión..." : "Entrar al panel"}
            </Button>
          </Form>
        </section>
      </div>
    </div>
  );
}
